import React from 'react'

// MATERIAL
import Typography from '@material-ui/core/Typography'
import SvgIcon from '@material-ui/core/SvgIcon'

export default class Contact extends React.Component{
    render(){
    return(
        <div>
            <div>
                <Typography className="title" style={{color: 'white', marginBottom: 10}} variant="title">
                    Contact
                </Typography>
            </div>
                <Typography style={{color: 'white'}} variant="body-2">
                    <SvgIcon style={{marginRight: 7, display: 'inline-flex', alignSelf: 'center', top: '.25em', position: 'relative'}}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/></svg>
                    </SvgIcon>
                        +54 11 3801 4401
                </Typography>  
                <Typography style={{color: 'white'}} variant="body-2">
                    <SvgIcon  style={{marginRight: 7, display: 'inline-flex', alignSelf: 'center', top: '.25em', position: 'relative'}}><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>
                    </SvgIcon>
                    <a style={{color: 'white', textDecoration: 'none'}} href="mailto: hi@lemonat.io">
                        hi@lemonat.io
                    </a>
                </Typography>
        </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/Components/Footer/Parts/Contact.js